import styled, { css } from 'styled-components'
import { transparentize } from 'polished'
import { motion } from 'framer-motion'

const Backdrop = styled.div`
  ${({ theme }) => css`
    position: fixed;
    z-index: 999999;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    padding: ${theme.spacing(2)};
    background-color: ${transparentize(0.5, theme.palette.black)};
  `}
`

const Dialog = styled(motion.div)`
  ${({ theme }) => css`
    width: fit-content;
    height: fit-content;
    max-height: 100%;
    overflow-y: auto;
    background-color: ${theme.palette.white};
    padding: ${theme.spacing(3)};
  `}
`

const Content = styled.div`
  ${({ theme }) => css`
    max-width: 72rem;

    button {
      height: 4.8rem;
      line-height: 4.8rem;
      padding: 0 ${theme.spacing(2)};
      appearance: none;
      border: 0 none;
      font-size: 1.6rem;
      background-color: ${theme.palette.black};
      color: ${theme.palette.white};

      &:hover {
        opacity: 0.75;
      }

      + button {
        margin-left: ${theme.spacing(2)};
      }

      &.reverse {
        background-color: ${theme.palette.white};
        color: ${theme.palette.black};
        text-decoration: underline;

        &:hover {
          background-color: ${theme.palette.grey[100]};
        }
      }
    }
  `}
`

const Preference = styled.div`
  ${({ theme }) => css`
    border-bottom: 0.1rem solid ${theme.palette.grey[500]};

    + * {
      padding-top: ${theme.spacing(5)};
    }
  `}
`

const PreferenceHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacing(2)};

    h4 {
      margin: 0;
      font-weight: 500;
    }
  `}
`

const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(2)};
    padding-top: ${theme.spacing(2)};
  `}
`

export default {
  Backdrop,
  Dialog,
  Content,
  Preference,
  PreferenceHeader,
  Actions,
}
